import { useFela } from 'react-fela';

import { Text } from '@/modules/ui';

import { useGroupsWithLocalizedAllUsersGroup } from '../../hooks';
import type { GroupWithPermissions } from '../../types';
import { GroupItem } from '../GroupItem';
import * as felaRules from './Groups.rules';

const defaultGroups: GroupWithPermissions[] = [];

export interface GroupsProps {
    groups: GroupWithPermissions[];
}

export const Groups = ({ groups = defaultGroups }) => {
    const { css } = useFela();

    const groupsWithLocalizedAllUsersGroup = useGroupsWithLocalizedAllUsersGroup(groups);

    return (
        <div className={css(felaRules.container)}>
            <Text variant='ParagraphSmallMedium' elementType='ul' customStyle={felaRules.list}>
                {groupsWithLocalizedAllUsersGroup.map(group => (
                    <GroupItem key={group.id} hasPasskey {...group} />
                ))}
            </Text>
        </div>
    );
};
